import styled from '@emotion/styled'
import {Dialog, DialogActions, Button} from '@mui/material'

const StyledCancelButton = styled(Button)(({theme}) => ({
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  }
}))
const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    paddingRight: '9px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box'
  }
}))

const StyledDialogActions = styled(DialogActions)(() => ({
  paddingBottom: '16px' // Add spacing above the actions
}))

const StyledButton = styled(Button)(({theme, color}) => ({
  border: '1px solid transparent',
  '&:hover': {
    backgroundColor: color === 'primary' ? theme.palette.hpPrimary : theme.palette.error.main,
    boxShadow: 'none'
  }
}))

export {StyledDialogActions, StyledDialog, StyledButton, StyledCancelButton}
